import script from "./OrderTickets.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderTickets.vue?vue&type=script&setup=true&lang=js"

import "./OrderTickets.vue?vue&type=style&index=0&id=cc5402b8&lang=scss"

const __exports__ = script;

export default __exports__